/* BigFanStore catalog mode: client-side defense in depth, not a server-side checkout kill switch. */
(() => {
  'use strict';
  if (!document.documentElement.classList.contains('bigfan-catalog-mode')) return;
  const isPurchasePath = (value) => {
    if (typeof value !== 'string' || !value) return false;
    try {
      const url = new URL(value, location.origin);
      if (url.origin !== location.origin) return false;
      const path = url.pathname.replace(/\/+$/, '');
      return /(?:^|\/)(?:cart|checkout)(?:\/|$|\.js$|\.json$)/i.test(path);
    } catch (_) { return false; }
  };
  const isPurchaseForm = (form) => form?.matches?.('[data-type="add-to-cart-form"], form[action*="/cart"], form[action*="/checkout"]') || isPurchasePath(form?.action);
  // Capture prevents custom storefront controls from invoking a cart purchase accidentally.
  document.addEventListener('submit', (event) => {
    if (!isPurchaseForm(event.target)) return;
    event.preventDefault(); event.stopImmediatePropagation();
  }, true);
  document.addEventListener('click', (event) => {
    const anchor = event.target.closest?.('a[href]');
    if (anchor && isPurchasePath(anchor.href)) {
      event.preventDefault(); event.stopImmediatePropagation();
      location.assign(document.querySelector('a.header__heading-link')?.href || '/');
      return;
    }
    const button = event.target.closest?.('button[name="add"],button[name="checkout"],[data-bigfan-sticky-submit]');
    if (button) {event.preventDefault();event.stopImmediatePropagation();}
  }, true);
})();
